import { atom } from 'recoil';

export type AuthPhase = 'idle' | 'loading' | 'ready' | 'error' | 'unauthorized';

export const authStatusState = atom<AuthPhase>({
  key: 'authStatusState',
  default: 'idle'
});

export const authErrorState = atom<string | null>({
  key: 'authErrorState',
  default: null
});